import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { useTranslation } from "react-i18next";
import type { LegalDocKey } from "../../constants/legal";
import { useStore } from "../../store/globalState";
import { LegalContent } from "./LegalContent";
import { ScrollToTop } from "../ScrollToTop";

interface LegalAccordionProps {
  docs: readonly LegalDocKey[];
}

const ChevronIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const LegalAccordion: React.FC<LegalAccordionProps> = ({ docs }) => {
  const { t } = useTranslation();
  const { bodyCopy, dropzoneColors } = useStore().theme.whiteView;
  const from = dropzoneColors?.[0];
  const to = dropzoneColors?.[1] ?? from;

  return (
    <div
      className="legal-accordion"
      style={{
        color: bodyCopy,
        ...(from
          ? {
              ["--legal-border" as string]: `linear-gradient(90deg, ${from}, ${to})`,
              ["--legal-border-solid" as string]: from,
            }
          : {}),
      }}
    >
      {docs.map((doc) => (
        <Disclosure key={doc}>
          {({ open }) => (
            <div className="legal-accordion-item">
              <DisclosureButton className="legal-accordion-trigger foreground">
                <span>{t(`legal.docs.${doc}`)}</span>
                <ChevronIcon
                  className={`legal-accordion-chevron ${open ? "open" : ""}`}
                />
              </DisclosureButton>
              <DisclosurePanel className="legal-accordion-panel">
                {/* Lazy: only mounts LegalContent when panel opens */}
                <LegalContent doc={doc} />
              </DisclosurePanel>
            </div>
          )}
        </Disclosure>
      ))}
      <ScrollToTop />
    </div>
  );
};
